import { WIDGET_LOG, WIDGET_EVENT } from '@/store/global';

const CHALLENGE_GUARD_PREFIX = '3ds-challenge-';
const SKIP_LOG_GUARD_PREFIX = '3ds-challenge-skip-logged-';

function buildPayload(action, source) {
  return {
    action: action || null,
    source,
    isFrame: window.self !== window.top,
  };
}

/**
 * Stable signature of a 3DS challenge
 */
export function getChallengeSignature(authPayload) {
  if (!authPayload) return null;

  try {
    return `${authPayload.mode}:${JSON.stringify(authPayload.content ?? {})}`;
  } catch (e) {
    return authPayload.mode || null;
  }
}

export function isChallengeInitiated(transactionId, signature) {
  if (!transactionId || !signature) return false;

  try {
    return (
      sessionStorage.getItem(CHALLENGE_GUARD_PREFIX + transactionId) ===
      signature
    );
  } catch (e) {
    return false;
  }
}

export function markChallengeInitiated(transactionId, signature) {
  if (!transactionId || !signature) return;

  try {
    sessionStorage.setItem(CHALLENGE_GUARD_PREFIX + transactionId, signature);
  } catch (e) {
    // sessionStorage unavailable
  }
}

export function shouldLogChallengeSkip(transactionId, signature) {
  if (!transactionId || !signature) return false;

  try {
    const key = SKIP_LOG_GUARD_PREFIX + transactionId;
    if (sessionStorage.getItem(key) === signature) return false;
    sessionStorage.setItem(key, signature);
    return true;
  } catch (e) {
    return false;
  }
}

export async function redirectTo3ds({
  dispatch,
  action,
  transactionId,
  source,
}) {
  const payload = buildPayload(action, source);

  if (!action) {
    dispatch(
      'sendLog',
      {
        logType: WIDGET_LOG.ERROR,
        message: '3DS redirect missing action URL',
        details: {
          transactionId,
          event: WIDGET_EVENT.THREEDS_REDIRECT_STALLED,
          eventUTC: new Date().toISOString(),
          payload,
        },
      },
      { root: true },
    );
    return;
  }

  await dispatch(
    'sendLog',
    {
      logType: WIDGET_LOG.INFO,
      message: 'Widget attempting 3DS redirect',
      details: {
        transactionId,
        event: WIDGET_EVENT.THREEDS_REDIRECT_ATTEMPT,
        eventUTC: new Date().toISOString(),
        payload,
      },
    },
    { root: true },
  );

  const stalledTimer = setTimeout(() => {
    dispatch(
      'sendLog',
      {
        logType: WIDGET_LOG.ERROR,
        message: '3DS redirect did not navigate away',
        details: {
          transactionId,
          event: WIDGET_EVENT.THREEDS_REDIRECT_STALLED,
          eventUTC: new Date().toISOString(),
          payload,
        },
      },
      { root: true },
    );
  }, 7000);

  window.addEventListener('pagehide', () => clearTimeout(stalledTimer), {
    once: true,
  });

  window.location.href = action;
}
